/**
 * Shared GEO fixtures used across frontend config modules.
 */
module.exports = [
  { label: 'Dortmund, Deutschland', location: { lat: 51.5136, lng: 7.4653 } },
  { label: 'Bochum, Deutschland', location: { lat: 51.4818, lng: 7.2162 } },
  { label: 'Recklinghausen, Deutschland', location: { lat: 51.6141, lng: 7.1979 } },
  { label: 'Gelsenkirchen, Deutschland', location: { lat: 51.5177, lng: 7.0857 } },
  { label: 'Castrop-Rauxel, Deutschland', location: { lat: 51.5474, lng: 7.3116 } },
  { label: 'Schwerte, Deutschland', location: { lat: 51.4452, lng: 7.5653 } },
];